import { Ajax, Get, Post, Put, Delete } from './Ajax'
import './utils'
import Collection from './vo/collection'
import Model from './vo/model'
import EventBus from './eventbus'
import URLs from './URLs'

export {
  Ajax,
  Get,
  Post,
  Put,
  Delete,
  Collection,
  Model,
  EventBus,
  URLs
}



// WEBPACK FOOTER //
// ./src/common/index.js